import {
  IBAN,
  BANK_NAME_AR,
  USERNAME,
  BANK_NAME_EN,
  SWIFT,
  BANK_NAME,
  BANK_COUNTRY,
  BANK_DOCUMENT,
  BANK_BRANCH,
  BENEFICIARY_ADDRESS,
} from "./constant";
import BankDocumentLink from "../../../../components/common/BankDocumentLink";
import {
  getBankSwiftCode,
  getCountryDisplayName,
  isInternationalBank,
} from "../../../../setup/util/internationalBank";

// material ui components
import Box from "@mui/material/Box";

// styles
import styles from "./styles.module.css";

const BankInfo = (props: any) => {
  const { data } = props;

  // Party outside KSA: any valid IBAN, free-text bank, SWIFT, optional branch and document.
  if (isInternationalBank(data)) {
    return (
      <div>
        <div className={styles.bankInfoSection}>
          <div>{USERNAME}</div>
          <div>{data?.beneficiaryName}</div>
        </div>
        <div className={styles.bankInfoSection}>
          <div>{IBAN}</div>
          <div>{data?.iban}</div>
        </div>
        <div className={styles.bankInfoSection}>
          <div>{BANK_NAME}</div>
          <div>{data?.bankName}</div>
        </div>
        <div className={styles.bankInfoSection}>
          <div>{BANK_COUNTRY}</div>
          <div>{getCountryDisplayName(data?.country)}</div>
        </div>
        <div className={styles.bankInfoSection}>
          <div>{SWIFT}</div>
          <div>{getBankSwiftCode(data) || "-"}</div>
        </div>
        {data?.branchName && (
          <div className={styles.bankInfoSection}>
            <div>{BANK_BRANCH}</div>
            <div>{data.branchName}</div>
          </div>
        )}
        <div className={styles.bankInfoSection}>
          <div>{BENEFICIARY_ADDRESS}</div>
          <div>{data?.beneficiaryAddress || "-"}</div>
        </div>
        <div className={styles.bankInfoSection}>
          <div>{BANK_DOCUMENT}</div>
          <div>
            <BankDocumentLink document={data?.document} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.bankInfoSection}>
        <div>{USERNAME}</div>
        <div>{data?.beneficiaryName}</div>
      </div>

      <div className={styles.bankInfoSection}>
        <div>{IBAN}</div>
        <div>{data?.iban}</div>
      </div>

      <div className={styles.bankInfoSection}>
        <div>{BANK_NAME_AR}</div>
        <div>{data?.bank?.arabicName}</div>
      </div>
      <div className={styles.bankInfoSection}>
        <div>{BANK_NAME_EN}</div>
        <div>{data?.bank?.englishName}</div>
      </div>

      <div className={styles.bankInfoSection}>
        <div>{SWIFT}</div>
        <div>{getBankSwiftCode(data)}</div>
      </div>
    </div>
  );
};

export default BankInfo;
